module.exports = __webpack_public_path__ + "img/help-icon.eb2b7bc7.svg";